import React from 'react';

const WhoCanJoin = () => {
  const profiles = [
    {
      icon: 'fa-ad',
      gradient: 'from-hector-blue to-cyan-400',
      title: 'Independent Freelancers',
      description: 'You\'re the expert they call when their DSP is a mess, or they\'re bleeding ad spend. One referral = 3-6 months of commission before they optimize.'
    },
    {
      icon: 'fa-building',
      gradient: 'from-hector-purple to-pink-400',
      title: 'Ex-Amazon Employees',
      description: 'You worked inside the system. You know what sellers struggle with. Your network is gold.'
    },
    {
      icon: 'fa-calculator',
      gradient: 'from-green-400 to-cyan-400',
      title: 'Financial Specialists',
      description: 'You audit Amazon seller financials. When you spot wasted ad spend, you know exactly who to call. Quick referral. Big commission.'
    },
    {
      icon: 'fa-shield-alt',
      gradient: 'from-yellow-400 to-orange-400',
      title: 'Compliance Consultants',
      description: 'You\'re embedded in seller communities. Your recommendations carry weight. One referral per quarter = income.'
    }
  ];

  return (
    <section id="who-can-join" className="py-20 bg-gradient-to-br from-hector-light-grey via-white to-hector-light-grey">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            The <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">4 Profiles</span> We're Looking For
          </h2>
          <p className="text-xl text-hector-dark-grey">
            We're specifically targeting people who own a community in the Amazon space:
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {profiles.map((profile, index) => (
            <div key={index} className="profile-card bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className={`w-16 h-16 bg-gradient-to-br ${profile.gradient} rounded-2xl flex items-center justify-center mb-4 mx-auto`}>
                <i className={`fas ${profile.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-hector-black text-center mb-4">{profile.title}</h3>
              <p className="text-gray-600 leading-relaxed text-center">
                {profile.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
 <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    JOIN THE NETWORK MAKING 4 - 5 FIGURES MONTHLY
  </button>
</a>

          <p className="text-sm text-gray-600">
            Real affiliates. Real payouts. Real 30-day payment schedule. <span className="font-bold text-hector-black">No clawbacks.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoCanJoin;
